/* unplugin-vue-components disabled */import { ElInput as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import __unplugin_components_2 from '~icons/ep/arrow-down';
import { ElIcon as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_0 from '~icons/ep/arrow-up';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-352bbee2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex-center"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "game-name"
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  class: "marginB10"
};
const _hoisted_6 = {
  class: "game-items"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "game-name"
};
import { Search } from '@element-plus/icons-vue';
import { storeToRefs } from 'pinia';
import { useClickOutside } from '@ultra/share/hooks';
import { apiAppGameList } from '@/api/app';
import { imgLimit } from '@ultra/share/utils';
import { useAppStore } from '@/store/modules/app';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const inputValue = ref('');
    const visible = ref(false);
    const gameList = ref([]);
    // const gameData = ref<any>([]);
    const {
      setGameInfo
    } = useAppStore();
    const {
      gameInfo
    } = storeToRefs(useAppStore());
    const getGameList = async (publish_status = 1, status = 1) => {
      const res = await apiAppGameList({
        publish_status,
        status
      });
      if (res.code === 0) {
        gameList.value = [...res.data];
      }
    };
    const contentRef = ref(null);
    const isClickOut = useClickOutside(contentRef);
    const handleClickItem = item => {
      visible.value = false;
      setGameInfo(item);
      //@ts-ignore
      window.staticFn.setCustomConfig({
        gameId: item.Id
      });
    };
    const toggle = () => {
      visible.value = !visible.value;
    };
    watch(() => isClickOut.value, val => {
      if (val) {
        visible.value = false;
      }
    });
    onMounted(async () => {
      await getGameList();
      //@ts-ignore
      window.staticFn.setCustomConfig({
        gameId: gameInfo.value.Id
      });
    });
    return (_ctx, _cache) => {
      const _component_i_ep_ArrowUp = __unplugin_components_0;
      const _component_el_icon = __unplugin_components_1;
      const _component_i_ep_ArrowDown = __unplugin_components_2;
      const _component_el_input = __unplugin_components_3;
      return _openBlock(), _createElementBlock("div", {
        class: "add-container",
        ref_key: "contentRef",
        ref: contentRef
      }, [_createElementVNode("div", {
        class: "change-game",
        onClick: toggle
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        style: {
          "width": "26px"
        },
        src: _unref(imgLimit)(_unref(gameInfo).Icon, 64),
        alt: ""
      }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(gameInfo).Name), 1)]), _withDirectives(_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_i_ep_ArrowUp)]),
        _: 1
      }, 512), [[_vShow, visible.value]]), _withDirectives(_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_i_ep_ArrowDown)]),
        _: 1
      }, 512), [[_vShow, !visible.value]])]), _withDirectives(_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
        modelValue: inputValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => inputValue.value = $event),
        placeholder: "输入游戏名称",
        "suffix-icon": _unref(Search)
      }, null, 8, ["modelValue", "suffix-icon"])]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputValue.value ? gameList.value.filter(item => item.Name.includes(inputValue.value)) : gameList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "game-item",
          key: item.Id,
          onClick: $event => handleClickItem(item)
        }, [_createElementVNode("img", {
          style: {
            "width": "30px"
          },
          src: _unref(imgLimit)(item.Icon, 64),
          alt: ""
        }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, _toDisplayString(item.Name), 1)], 8, _hoisted_7);
      }), 128))])], 512), [[_vShow, visible.value]])], 512);
    };
  }
});